import React from 'react'
import FundraiserAssets from '../../components/Fundraiser/FundraiserAssets';

const Assets = () => {
  return (
    <FundraiserAssets />
  )
}

export default Assets;